import { Box, Layer, Text } from 'grommet';
import React from 'react';
import "./AssignModal.css";
import assign from '../../../../../../../assets/assign-modal.gif';
import { useStore } from '../../../../../../../Hooks/useStore';

const AssignToMeModal = ({ isShow }) => {
    const { rootStore } = useStore();

    const onAssignToMeClick = () => {
        rootStore.emsStore.handleAssignToMeModal(false);
        rootStore.emsStore.resetSelectedMedicalIdListEms();
        rootStore.emsStore.resetSelectedMedicalIdList();
        rootStore.emsStore.handleNewEmergency();
        rootStore.emsStore.handleActiveTab(0);
    }
    
    return (
        <>
            {
                isShow
                    ?
                    <Layer>
                        <Box className='assign-modal-container'>
                            <img src={assign} className='assing-modal-img' />
                            <p className="assign-incident-desc">Medical Incident <Text className='assign-whom'>assigned to you.</Text></p>
                            <button onClick={onAssignToMeClick} className='assing-modal-btn'>Go to ‘Assign to me’</button>
                        </Box>
                    </Layer>
                    :
                    null
            }
        </>
    );
}

export default AssignToMeModal;